import Head from "next/head";
import { fetchGetBanners } from "../../../services/api";
import SingleBanner from "../../components/default/single-banner";
import Footer from "../../components/layout/footer";
import Header from "../../components/layout/header";
import SellYourVehicleForm from "../../components/sell-your-vehicle/sell-your-vehicle-form";

export default function SellYourVehiclePage({ companyGeneralData, banner }) {
    companyGeneralData = JSON.parse(companyGeneralData);

    return (
        <>
            <Head>
                <meta charSet="utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="description" content="Quer vender seu carro? Aqui seu veículo recebe a melhor avaliação do mercado e pagamos a vista." />
                <meta name="author" content="https://bndv.com.br" />
                <title>{`${(companyGeneralData.company.nickName).toUpperCase()} - ${companyGeneralData.company.city ? companyGeneralData.company.city : ''} - Compramos seu Veículo`}</title>
            </Head>

            <div className="main-wrapper">
                <Header company={companyGeneralData.company} />
                {banner ? <SingleBanner imageUrl={banner.imageUrl} /> : null}
                <SellYourVehicleForm />
                <Footer company={companyGeneralData.company} />
            </div>
        </>
    )
}

export async function getServerSideProps() {
    const banners = await fetchGetBanners({ idMenuOption: 10 });

    return {
        props: {
            banner: (banners && banners.length > 0) ? banners[0].banner : null
        }
    }
}